import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { IonInfiniteScroll, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { MdlFiltroPage } from 'src/app/pages/mdl-filtro/mdl-filtro.page';
import { MdlResEncuestasPage } from 'src/app/pages/mdl-res-encuestas/mdl-res-encuestas.page';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';
import { SocketService } from 'src/app/services/socket.service';
import { MasivosService } from 'src/app/services/masivos.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reporte-plantillas',
  templateUrl: './reporte-plantillas.component.html',
  styleUrls: ['./reporte-plantillas.component.scss'],
})
export class ReportePlantillasComponent implements OnInit {
  @ViewChild('scrollPlantilla') infiniteScrollPlantilla: IonInfiniteScroll;
  fechaInicial: any;
  fechaFinal: any;
  tel = new FormControl('');
  classUser: any;
  vista: any;
  loading: any;
  regPlantilla: any;
  searchReporte: string;
  arrayPlantillas: any;
  totalFiltro: number;
  dataFiltro: any;
  arrFiltro: any;
  totalRegistros: number;
  arrDescarga: any;
  paginacion: number;
  pagina: number;
  descarga: any;
  totalPag: number;
  arrPlantillas: any;
  banderaNum: boolean;
  idAdmin;
  storageUsuario;
  correo;
  idAgente;
  fechaSelect: string;
  arrDatos: any;
  mostrarBotonVolver: boolean;

  canal: any;
  canales: any;
  canalInicial: any;

  constructor(
    private storage: Storage,
    private serviceWa: WhatsappService,
    private formatdate: DatePipe,
    public loadingController: LoadingController,
    public toastCtrl: ToastController,
    private modalCtrl: ModalController,
    public wsService: SocketService,
    private masivosService: MasivosService,
    private router: Router

  ) {
    this.canales = [];
    this.arrDatos = [];
    this.banderaNum = true;
    this.arrPlantillas = {};
    this.pagina = 1;
    this.paginacion = 0;
    this.dataFiltro = {
      tipoFecha: 'envio',
      agente: [],
      numero: '',
      resultado: [],
      origen: [],
      plantillas: [],
      equipos: [],
      tipoEnv: []
    };
    this.arrFiltro = {
      agentes: [],
      resultados: [],
      origen: [],
      plantillas: [],
      equipo: [],
      tipoEnv: []
    };
    this.arrDescarga = [];
    this.vista = 1;
  }

  async ionViewWillEnter() {
  }

  ngOnInit() {
    this.getCanal();
    this.fechaFinal = new FormControl();
    this.fechaInicial = new FormControl();
    this.classUser = new ValidarToken(this.storage);
    this.totalFiltro = 0;
    setTimeout(() => {
      // this.consultaRegPlantilla(0, 0);
    }, 200);
    this.regPlantilla = [];
    this.arrayPlantillas = [];
    this.mostrarBotonVolver = this.router.url.includes('masivos');
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    // console.log(this.canales, 'canales ');
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    await this.storage.get('usuario').then((usuario) => {
      this.storageUsuario = usuario;
      // console.log(this.storageUsuario, 'desde menu')

    })
      .then(() => {
        // this.idAdmin =  this.storageUsuario.idAdmin;
        this.correo = this.storageUsuario.correo;
        this.idAgente = this.storageUsuario.idAgente;
      })

      .then(() => {
        this.wsService.loginWS(this.correo, this.canalInicial.canale.idAdmin_sec, this.idAgente, this.canal.idAdmin_sec);
      })
    // console.log(this.canal.url_back, 'url de back desde storage');
  }

  descargar() {
    const fechaInicioDate = new Date(this.fechaInicial.value);
    const fechaFinDate = new Date(this.fechaFinal.value);
    const MILISEGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;

    const diferenciaDias = (fechaFinDate.getTime() - fechaInicioDate.getTime()) / MILISEGUNDOS_POR_DIA;

    if (diferenciaDias <= 90) {
      this.descarga = true;
      this.presentToast('Iniciando descarga', 'success');
      if (this.fechaInicial.value) {
        this.consultaRegPlantilla(1, 0);
      } else {
        this.consultaRegPlantilla(0, 0);
      }
      this.descarga = false;
      // this.serviceWa.exportAsExcelFile(this.arrDescarga, `Reporte-Plantillas-${this.formatdate.transform(new Date(),
      //   'dd-MM-yyyy-HH-mm-ss')}`);
    } else {
      this.presentToast('No se puede realizar una descarga mayor a 3 meses', 'danger');
    }

    this.fechaFinal.reset();
    this.fechaInicial.reset();
  }

  resetFiltro() {
    this.tel.reset();
    this.fechaFinal.reset();
    this.fechaInicial.reset();
    this.dataFiltro = {
      tipoFecha: 'envio',
      agente: [],
      numero: '',
      resultado: [],
      origen: [],
      plantillas: [],
      equipos: [],
      tipoEnv: []
    };
    this.arrFiltro = {
      agentes: [],
      resultados: [],
      origen: [],
      plantillas: [],
      equipo: [],
      tipoEnv: []
    };
    this.totalFiltro = 0;
  }

  busqueda(ev) {
    // console.log(ev);
    this.tel.setValue(ev.detail.value);
    if (this.tel.value) {
      if (this.tel.value.length < 6) {
        this.banderaNum = false;
      } else {
        this.banderaNum = true;
      }
      this.dataFiltro.numero = this.tel.value;
    } else {
      this.dataFiltro.numero = ``;
    }
    // console.log(this.dataFiltro.numero, this.tel.value);
  }

  consultaRegPlantilla(val, tipoConsulta) {
    this.arrayPlantillas = [];
    if (this.tel.value) {
      this.dataFiltro.numero = this.tel.value;
    }

    let pag = this.paginacion;
    let des = 0;
    if (tipoConsulta == 1) {
      pag = 0;
      this.pagina = 1;
    }
    if (this.descarga) {
      pag = 0;
      des = 1;
      this.dataFiltro.nombre = `Reporte-Plantillas-${this.formatdate.transform(new Date(),
        'dd-MM-yyyy-HH-mm-ss')}`;
      // this.loading.dismiss();
    } else {
      this.presentLoading('Cargando conversaciones...');
    }

    let query = `ad_planIt=true&paginacion=${pag}&descarga=${des}`;
    if (val > 0) {
      // console.log(this.fechaFinal.value, this.fechaInicial.value);
      let feIn = new Date(this.fechaInicial.value);
      let feFin = new Date(this.fechaFinal.value);
      // const fePrueba = Date.parse(this.fechaInicial.value);
      if (val === 2) {
        feIn = this.fechaInicial.value;
        feFin = this.fechaFinal.value;
      }

      feIn.toUTCString();
      feFin.toUTCString();
      const dayIn = feIn.getUTCDate();
      const dayFin = feFin.getUTCDate();
      if (val === 2) {
        feIn.setUTCDate(dayIn);
        feFin.setUTCDate(dayFin);
      } else {
        feIn.setUTCDate(dayIn + 1);
        feFin.setUTCDate(dayFin + 1);
      }
      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);
      console.log(feIn);
      console.log(feFin);
      query = `inicio=${feIn}&fin=${feFin}&ad_planIt=true&paginacion=${pag}&descarga=${des}`;
    }
    // return;
    // console.log(query);
    this.serviceWa.reportePlantillas(this.idAdmin, query, this.canalInicial.id,
      this.canalInicial.rol, this.canalInicial.token, this.dataFiltro, this.canalInicial.canale.url_back).subscribe(
        (res: any) => {
          console.log(res);
          if (des === 0) {
            this.loading.dismiss();
          }
          const { status, message } = res;
          if (status === 'success') {
            const { regPlantilla } = res;
            //  console.log(regPlantilla);
            if (this.classUser.idAdmin == 40) {
              this.consultaRegPlantillaMasivos(val, tipoConsulta, regPlantilla, res.total);
            } else {
              this.formatTable(regPlantilla);
              this.totalRegistros = res.total;
              this.totalPag = Math.round(this.totalRegistros / 1000);
              if (this.totalRegistros <= 1000) {
                this.totalPag = 1;
              }
            }
            //  this.conversaciones.forEach(element => {
            //   element.conversacion.createdAt = new Date(element.conversacion.createdAt);
            //  });
            //  console.log(this.conversaciones);
            if (des === 0) {
              this.presentToast('Datos encontrados!', 'success');
            }
            //  this.vista = 1;
          }
          else {
            if (this.classUser.idAdmin == 40) {
              this.consultaRegPlantillaMasivos(val, tipoConsulta, [], 0);
            } else {
              this.presentToast('No se encontrarón conversaciones', 'danger');
            }
          }
        },
        erro => {
          console.log(erro);
          if (!this.descarga) {
            this.loading.dismiss();
          }
        });
  }

  consultaRegPlantillaMasivos(val, tipoConsulta, registroPlantilla, total) {
    // this.arrayPlantillas = [];
    if (this.tel.value) {
      this.dataFiltro.numero = this.tel.value;
    }

    let pag = this.paginacion;
    let des = 0;
    if (tipoConsulta == 1) {
      pag = 0;
      this.pagina = 1;
    }

    let query = `ad_planIt=true&paginacion=${pag}&descarga=${des}`;
    if (val > 0) {
      // console.log(this.fechaFinal.value, this.fechaInicial.value);
      let feIn = new Date(this.fechaInicial.value);
      let feFin = new Date(this.fechaFinal.value);
      // const fePrueba = Date.parse(this.fechaInicial.value);
      if (val === 2) {
        feIn = this.fechaInicial.value;
        feFin = this.fechaFinal.value;
      }

      feIn.toUTCString();
      feFin.toUTCString();
      const dayIn = feIn.getUTCDate();
      const dayFin = feFin.getUTCDate();
      if (val === 2) {
        feIn.setUTCDate(dayIn);
        feFin.setUTCDate(dayFin);
      } else {
        feIn.setUTCDate(dayIn + 1);
        feFin.setUTCDate(dayFin + 1);
      }
      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);
      query = `inicio=${feIn}&fin=${feFin}&ad_planIt=true&paginacion=${pag}&descarga=${des}`;
    }
    // return;
    // console.log(query);
    this.serviceWa.reportePlantillasMasivos(this.idAdmin, query, this.classUser.id,
      this.classUser.rol, this.classUser.token, this.dataFiltro).subscribe(
        (res: any) => {
          const { status, message } = res;
          if (status === 'success') {
            const { regPlantilla } = res;
            //  console.log(regPlantilla);
            const regPlant = regPlantilla.concat(registroPlantilla);
            this.formatTable(regPlant);
            this.totalRegistros = res.total + total;
            this.totalPag = Math.round(this.totalRegistros / 1000);
            if (this.totalRegistros <= 1000) {
              this.totalPag = 1;
            }
            //  this.conversaciones.forEach(element => {
            //   element.conversacion.createdAt = new Date(element.conversacion.createdAt);
            //  });
            //  console.log(this.conversaciones);
            //  this.vista = 1;
          }
          else {
            if (registroPlantilla.length > 0) {
              this.totalRegistros = total;
              this.totalPag = Math.round(this.totalRegistros / 1000);
              if (this.totalRegistros <= 1000) {
                this.totalPag = 1;
              }
              this.formatTable(registroPlantilla);
            } else {
              this.presentToast('No se encontrarón conversaciones', 'danger');
            }
          }
        },
        erro => {
          console.log(erro);
        });
  }

  menosPag() {
    // console.log(this.pagina, this.paginacion, 'menos');
    if (this.paginacion > 0) {
      this.paginacion = this.paginacion - 1000;
      this.pagina = this.pagina - 1;
    }

    if (this.fechaInicial.value) {
      this.consultaRegPlantilla(1, 0);
    } else {
      this.consultaRegPlantilla(0, 0);
    }

    // console.log(this.pagina, this.paginacion, 'menos');
  }

  masPag() {
    // console.log(this.pagina, this.paginacion, 'mas');
    this.paginacion = this.paginacion + 1000;
    this.pagina = this.pagina + 1;

    if (this.fechaInicial.value) {
      this.consultaRegPlantilla(1, 0);
    } else {
      this.consultaRegPlantilla(0, 0);
    }
    // console.log(this.pagina, this.paginacion, 'mas');
  }

  formatTable(regPlantillas) {
    this.regPlantilla = regPlantillas.map((plantilla) => {

      let enviado;
      let recibido;
      let sinRecibir;
      let leido;
      let noenviado;
      let equipo = 'Por definir';
      let agent = '-';
      let tipoEnvio = '';
      let conNoEnv = '';

      if (plantilla.sucursale) {
        equipo = plantilla.sucursale.nombre;
      }
      if (plantilla.agente) {
        agent = `${plantilla.agente.nombre} ${plantilla.agente.apellido}`;
      }

      if (plantilla.equipo > 0 && plantilla.idAgente === 0) {
        tipoEnvio = 'Plantilla por Masivo';
      } else if (plantilla.equipo === 0 && plantilla.idAgente > 0) {
        tipoEnvio = 'Plantilla Individual';
      }

      if (plantilla.status === 4 || plantilla.status === 5 || plantilla.status === 6) {
        enviado = 0;
        recibido = 0;
        sinRecibir = 0;
        leido = 0;
        noenviado = 1;
      } else if (plantilla.status === 3) {
        enviado = 1;
        recibido = 1;
        sinRecibir = 1;
        leido = 1;
        noenviado = 0;
      } else if (plantilla.status === 2) {
        enviado = 1;
        recibido = 1;
        sinRecibir = 1;
        leido = 0;
        noenviado = 0;
      } else if (plantilla.status === 1) {
        enviado = 1;
        recibido = 0;
        sinRecibir = 1;
        leido = 0;
        noenviado = 0;
      } else if (plantilla.status === 0) {
        enviado = 1;
        recibido = 0;
        sinRecibir = 0;
        leido = 0;
        noenviado = 0;
      }

      if (plantilla.status === 4) {
        conNoEnv = 'Error en el número';
      } else if (plantilla.status === 5) {
        conNoEnv = 'Número activo';
      } else if (plantilla.status === 6) {
        conNoEnv = 'Número en lista negra';
      }

      this.arrPlantillas = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Telefono: plantilla.numero_destino,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Nombre Plantilla': plantilla.nombre_plantilla,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Equipo': equipo,
        'Agente': agent,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Tipo Envio': tipoEnvio,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Mensaje Enviado': enviado,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Mensaje recibido': recibido,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Mensaje Leído': leido,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Mensaje no enviado': noenviado,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Concepto no enviado': conNoEnv,
        'Respondido': plantilla.status_conver,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Fecha de envío': this.formatdate.transform(plantilla.createdAt, 'dd/MM/yyyy HH:mm:ss'),
        // eslint-disable-next-line quote-props
      }

      if (this.classUser.idAdmin === 45) {
        this.arrPlantillas.order_number = plantilla.dato1;
        this.arrPlantillas.tracking_number = plantilla.dato2;
        this.arrPlantillas.order_id = plantilla.dato3;
      }

      if (plantilla.layoutMasiv && this.classUser.idAdmin === 47) {
        const datos = JSON.parse(plantilla.layoutMasiv.datos)
        const dataKey = Object.keys(datos);

        dataKey.forEach(element => {
          if (element.toLocaleLowerCase() != 'whatsapp' && element.toLocaleLowerCase() != 'telefono'
            && element.toLocaleLowerCase() != 'teléfono' && element.toLocaleLowerCase() != 'numero' &&
            element.toLocaleLowerCase() != 'número' && element.toLocaleLowerCase() != 'unique_id') {
            if (!Number(element)) {
              if (!this.arrDatos.includes(element)) {
                this.arrDatos.push(element)
              }
            }
          }
        });
        // console.log(this.arrDatos)

        this.arrPlantillas.expediente = datos['unique_id'];
        this.arrDatos.forEach(data => {
          // console.log(data.toLocaleLowerCase());
          this.arrPlantillas[data] = datos[data];
        });
        this.arrPlantillas.fecha_expediente = plantilla.fecha_expediente;
        // this.arrPlantillas.fecha_expediente = datos['Fecha Expediente'];
        // this.arrPlantillas.cuenta = datos['Cuenta'];
        // this.arrPlantillas.subservicio = datos['Subservicio'];
        // this.arrPlantillas.servicio = datos['Servicio'];
        // this.arrPlantillas.correo = datos['Correo'];
        // this.arrPlantillas.municipio = datos['Municipio'];
        // this.arrPlantillas.lugarEv = datos['Lugar evento'];
        // this.arrPlantillas.clModulo = datos['clModulo'];
        // this.arrPlantillas.tipoBase = datos['Tipo base'];
        this.arrPlantillas.encuesta = plantilla.encuesta;
        this.arrPlantillas.reenvio = plantilla.reenvio;
        this.arrPlantillas.unique_encuesta = plantilla.unique_id;
        // console.log(this.arrPlantillas, 'Datos dinámicos');
      }
      // else if(!plantilla.layoutMasiv && this.classUser.idAdmin === 47) {
      //   this.arrPlantillas.expediente = '';
      //   this.arrPlantillas.fecha_expediente = '';
      //   this.arrPlantillas.cuenta = '';
      //   this.arrPlantillas.subservicio = '';
      //   this.arrPlantillas.servicio = '';
      //   this.arrPlantillas.correo = '';
      //   this.arrPlantillas.municipio = '';
      //   this.arrPlantillas.lugarEv = '';
      //   this.arrPlantillas.clModulo = '';
      //   this.arrPlantillas.tipoBase = '';
      //   this.arrPlantillas.encuesta = plantilla.encuesta;
      //   this.arrPlantillas.reenvio = plantilla.reenvio;
      //   this.arrPlantillas.unique_encuesta = plantilla.unique_id;
      // }

      if (plantilla.layoutMasiv && this.classUser.idAdmin === 57) {
        const datos = JSON.parse(plantilla.layoutMasiv.datos)
        const dataKey = Object.keys(datos);

        dataKey.forEach(element => {
          if (element.toLocaleLowerCase() != 'whatsapp' && element.toLocaleLowerCase() != 'telefono'
            && element.toLocaleLowerCase() != 'teléfono' && element.toLocaleLowerCase() != 'numero' &&
            element.toLocaleLowerCase() != 'número' && element.toLocaleLowerCase() != 'unique_id') {
            if (!Number(element)) {
              if (!this.arrDatos.includes(element)) {
                this.arrDatos.push(element)
              }
            }
          }
        });
        // console.log(this.arrDatos)

        // this.arrPlantillas.expediente = datos['unique_id'];
        this.arrDatos.forEach(data => {
          // console.log(data.toLocaleLowerCase());
          this.arrPlantillas[data] = datos[data];
        });
        // this.arrPlantillas['subservicio'] = datos['subservicio'];
        // this.arrPlantillas['SERVICIO'] = datos['SERVICIO'];
        // this.arrPlantillas['EXPEDIENTE'] = datos['EXPEDIENTE'];
        // this.arrPlantillas['FECHAAPERTURA'] = datos['FECHA APERTURA'];
        // this.arrPlantillas['CIUDAD'] = datos['CIUDAD'];
        // this.arrPlantillas['DEPARTAMENTO'] = datos['DEPARTAMENTO'];
        // this.arrPlantillas['RAMO'] = datos['RAMO'];
        // this.arrPlantillas['nombre cliente'] = datos['nombre cliente'];
        // this.arrPlantillas.empresa = datos['empresa'];
        // this.arrPlantillas.encuesta = plantilla.encuesta;
        // this.arrPlantillas.unique_encuesta = plantilla.unique_id;
      }
      //  else if(!plantilla.layoutMasiv && this.classUser.idAdmin === 57) {
      //   this.arrPlantillas['subservicio'] = '';
      //   this.arrPlantillas['nombre cliente'] = '';
      //   this.arrPlantillas.empresa = '';
      //   this.arrPlantillas.encuesta = plantilla.encuesta;
      //   this.arrPlantillas.unique_encuesta = plantilla.unique_id;
      // }

      // if(plantilla.sucursale || plantilla.agente) {
      return this.arrPlantillas;
      // }
    });
    // console.log(this.regPlantilla.length);
    // this.totalRegistros = this.regPlantilla.length;
    this.arrDescarga = this.regPlantilla;
    // console.log(this.arrDescarga);
    this.generateItems();
    this.vista = 1;
  }

  async openMdlFiltro() {
    let id;
    // if(tipo == 1) {
    //   id = this.idStatus;
    // } else if(tipo == 2) {
    //   id = this.idAgente;
    // } else {
    //   id = this.origen.value;
    // }
    const modal = await this.modalCtrl.create({

      component: MdlFiltroPage,
      componentProps: {
        dataInfo: this.canalInicial,
        arrFiltro: this.arrFiltro,
        reporte: 2
      },
      mode: 'ios',
      cssClass: 'modalFiltro'
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
    this.arrFiltro = data.filtro;
    if (data.filtro.agentes.length > 0) {
      this.dataFiltro.agente = data.filtro.agentes;
    } else {
      this.dataFiltro.agente = [];
    }
    if (data.filtro.plantillas.length > 0) {
      this.dataFiltro.plantillas = data.filtro.plantillas;
    } else {
      this.dataFiltro.plantillas = [];
    }
    if (data.filtro.equipo.length > 0) {
      this.dataFiltro.equipos = data.filtro.equipo;
    } else {
      this.dataFiltro.equipos = [];
    }

    if (data.filtro.tipoEnv.length > 0) {
      this.dataFiltro.tipoEnv = data.filtro.tipoEnv;
    } else {
      this.dataFiltro.tipoEnv = [];
    }
    // if(data.filtro.resultados.length > 0) {
    //   this.dataFiltro.resultado = data.filtro.resultados;
    // } else {
    //   this.dataFiltro.resultado = [];
    // }
    // if(data.filtro.origen.length > 0) {
    //   this.dataFiltro.origen = data.filtro.origen;
    // } else {
    //   this.dataFiltro.origen = [];
    // }
    this.totalFiltro = data.filtro.agentes.length + data.filtro.plantillas.length + data.filtro.equipo.length
      + data.filtro.tipoEnv.length;
    // console.log(this.arrFiltro, this.dataFiltro);
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      //message: mensaje,
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png" ></ion-img>'

    });
    await this.loading.present();
  }

  async openMdlRespuestas(respuesta) {
    const modal = await this.modalCtrl.create({

      component: MdlResEncuestasPage,
      componentProps: {
        respuesta,
        user: this.canalInicial
        // conversacion,
        // agente,
        // cliente,
        // nombreCliente
      },
      cssClass: ''
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
  }

  onIonInfinite(ev) {
    this.generateItems();
    setTimeout(() => {
      if (this.regPlantilla.length === 0) {
        this.infiniteScrollPlantilla.complete();
        this.infiniteScrollPlantilla.disabled = true;
      }

      this.infiniteScrollPlantilla.complete();
    }, 1000);
  }

  generateItems() {
    let copiaPlantilla = [];

    if (this.regPlantilla.length > 0 && this.regPlantilla.length >= 40) {
      copiaPlantilla = this.regPlantilla.slice(0, 40);
      this.arrayPlantillas.push(...copiaPlantilla);
      this.regPlantilla.splice(0, 40);

    }
    if (this.regPlantilla.length > 0 && this.regPlantilla.length <= 40) {
      copiaPlantilla = this.regPlantilla.slice(0, this.regPlantilla.length);
      this.arrayPlantillas.push(...copiaPlantilla);
      this.regPlantilla.splice(0, this.regPlantilla.length);

    }
    // console.log(this.regPlantilla, 'array a mostrar');
  }



  busquedaReporte(ev) {
    this.searchReporte = ev.detail.value;
  }

  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

  onSelectChange(event: any) {
    this.fechaSelect = event.detail.value;
    this.dataFiltro.tipoFecha = this.fechaSelect;
    console.log(this.fechaSelect);
  }

  vistaAnterior() {
    this.masivosService.setMostrarMasivos(true);
    this.masivosService.setMostrarReportePlantillas(false);
  }
}
